import React, { createContext, FC, PropsWithChildren, useContext, useState } from 'react';
import { VIEW_MODE } from '../utils/helpers';
import { reportDesktopView, reportMobileView, reportTabletView } from '../utils/bi';

interface UIContextShape {
  viewMode: VIEW_MODE;
  toggleViewMode: (viewMode: VIEW_MODE) => void;
  isInfoShown: boolean;
  setIsInfoShown: (isInfoShown: boolean) => void;
}

export const defaultUIContextValue: UIContextShape = {
  viewMode: VIEW_MODE.DESKTOP,
  toggleViewMode: () => {},
  isInfoShown: false,
  setIsInfoShown: () => {},
};

export const UIContext = createContext(defaultUIContextValue);

export const useUIContext = () => useContext(UIContext);

export const UIContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [viewMode, setViewMode] = useState(VIEW_MODE.DESKTOP);
  const [isInfoShown, setIsInfoShown] = useState(false);

  const toggleViewMode = (newValue: VIEW_MODE) => {
    if (viewMode === VIEW_MODE.DESKTOP) {
      reportDesktopView();
    }
    if (viewMode === VIEW_MODE.TABLET) {
      reportTabletView();
    }
    if (viewMode === VIEW_MODE.MOBILE) {
      reportMobileView();
    }

    setViewMode(newValue);
  };

  const contextValue: UIContextShape = {
    viewMode,
    toggleViewMode,
    isInfoShown,
    setIsInfoShown,
  };

  return <UIContext.Provider value={contextValue} children={children} />;
};
